// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../../common/http.res.js");
var Image$ReactHooksTemplate = require("../../common/image.res.js");
var Utils$ReactHooksTemplate = require("../../common/utils.res.js");
var Filter$ReactHooksTemplate = require("../filters/filter.res.js");
var Loading$ReactHooksTemplate = require("./Loading.res.js");
var Dashboard$ReactHooksTemplate = require("./dashboard.res.js");
var ListFilter$ReactHooksTemplate = require("../filters/listFilter.res.js");
var DashboardComponent$ReactHooksTemplate = require("./DashboardComponent.res.js");

function lableFunction(a, b) {
  console.log(a);
  console.log(b);
  return ('<p>' + a.title + '</p><ul><li>NPS: ' + a.nps + '</li></ul>');
}

var initialState = {
  loading: true,
  dashboard: undefined,
  dashboards: /* [] */0,
  drillDownChartDetails: undefined,
  currentRef: undefined
};

function buildNavigationParam(navigationIds) {
  return Belt_List.reduce(Belt_List.map(navigationIds, (function (prim) {
                    return String(prim);
                  })), "", (function (x, y) {
                if (x === "") {
                  return y;
                } else {
                  return x + "," + y;
                }
              }));
}

function reducer(state, x) {
  if (typeof x !== "object") {
    return {
            loading: true,
            dashboard: state.dashboard,
            dashboards: state.dashboards,
            drillDownChartDetails: state.drillDownChartDetails,
            currentRef: state.currentRef
          };
  }
  switch (x.TAG) {
    case "FetchDashboardCompleted" :
        var dashboardId = x._1;
        var dashboards = x._0;
        var defaultDashboard = List.find_opt(Dashboard$ReactHooksTemplate.default, dashboards);
        var headOfList = defaultDashboard !== undefined ? Caml_option.some(Caml_option.valFromOption(defaultDashboard)) : Belt_List.head(dashboards);
        var selectedDashboard;
        if (dashboardId !== undefined) {
          var x$1 = List.find_opt((function (x) {
                  return Dashboard$ReactHooksTemplate.id(x) === dashboardId;
                }), dashboards);
          if (x$1 !== undefined) {
            selectedDashboard = Caml_option.some(Caml_option.valFromOption(x$1));
          } else {
            RescriptReactRouter.push("/404");
            window.location.reload();
            selectedDashboard = undefined;
          }
        } else {
          selectedDashboard = defaultDashboard !== undefined ? Caml_option.some(Caml_option.valFromOption(defaultDashboard)) : headOfList;
        }
        console.log(headOfList);
        var dashboard = selectedDashboard !== undefined ? Caml_option.some(Caml_option.valFromOption(selectedDashboard)) : defaultDashboard;
        return {
                loading: false,
                dashboard: dashboard,
                dashboards: dashboards,
                drillDownChartDetails: state.drillDownChartDetails,
                currentRef: dashboard
              };
    case "DrillDown" :
        return {
                loading: state.loading,
                dashboard: state.dashboard,
                dashboards: state.dashboards,
                drillDownChartDetails: x._0,
                currentRef: state.currentRef
              };
    case "ChangeDashboard" :
        var x$2 = x._0;
        return {
                loading: state.loading,
                dashboard: Caml_option.some(x$2),
                dashboards: state.dashboards,
                drillDownChartDetails: undefined,
                currentRef: Caml_option.some(x$2)
              };
    case "GoToLinkedDashboard" :
        var x$3 = x._0;
        var dashboardId$1 = Dashboard$ReactHooksTemplate.id(x$3);
        var navigationParam = buildNavigationParam(x._1);
        RescriptReactRouter.push("/dashboard/" + String(dashboardId$1) + "?navigation=" + navigationParam);
        return {
                loading: state.loading,
                dashboard: state.dashboard,
                dashboards: state.dashboards,
                drillDownChartDetails: undefined,
                currentRef: Caml_option.some(x$3)
              };
    case "GoToClickedDashboard" :
        var nvaigationIds = x._2;
        var x$4 = x._0;
        var match = Belt_List.splitAt(nvaigationIds, x._1 - 1 | 0);
        var navigationParam$1 = buildNavigationParam(match !== undefined ? match[0] : nvaigationIds);
        var url = "/dashboard/" + String(Dashboard$ReactHooksTemplate.id(x$4));
        RescriptReactRouter.push(navigationParam$1 === "" ? url : url + "?navigation=" + navigationParam$1);
        return {
                loading: state.loading,
                dashboard: state.dashboard,
                dashboards: state.dashboards,
                drillDownChartDetails: undefined,
                currentRef: Caml_option.some(x$4)
              };
    
  }
}

function Dashboards(props) {
  var dashboardId = props.dashboardId;
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var queryParams = Querystringify.parse(props.search);
  var x = Js_dict.get(queryParams, "navigation");
  var navigationIds = x !== undefined && x !== "" ? List.map(Caml_format.int_of_string, Belt_List.fromArray(Js_string.split(",", x))) : /* [] */0;
  var breadCrumbs = function (navigationIds) {
    return Belt_List.concat(Belt_List.map(navigationIds, (function (x) {
                      return List.find((function (d) {
                                    return Dashboard$ReactHooksTemplate.id(d) === x;
                                  }), state.dashboards);
                    })), {
                hd: Belt_Option.getExn(state.currentRef),
                tl: /* [] */0
              });
  };
  var clearTempFilter = function (param) {
    return Http$ReactHooksTemplate.fetchPostEncodedJSON("/api/v1/filters", Json_encode.object_({
                    hd: [
                      "scope",
                      "temporary"
                    ],
                    tl: {
                      hd: [
                        "filters",
                        Json_encode.list(Filter$ReactHooksTemplate.encode, /* [] */0)
                      ],
                      tl: /* [] */0
                    }
                  }));
  };
  React.useEffect((function (param) {
          Js_promise.$$catch((function (err) {
                  return Promise.resolve((console.log(err), undefined));
                }), Js_promise.then_((function (result) {
                      return Promise.resolve((console.log(result), undefined));
                    }), Js_promise.then_((function (param) {
                          Curry._1(dispatch, "FetchDashboardInProgress");
                          return Js_promise.$$catch((function (err) {
                                        console.log(err);
                                        return Promise.resolve(Curry._1(dispatch, {
                                                        TAG: "FetchDashboardCompleted",
                                                        _0: /* [] */0,
                                                        _1: undefined
                                                      }));
                                      }), Js_promise.then_((function (xs) {
                                            return Promise.resolve((setTimeout((function (param) {
                                                                Curry._1(dispatch, {
                                                                      TAG: "FetchDashboardCompleted",
                                                                      _0: xs,
                                                                      _1: dashboardId
                                                                    });
                                                              }), Utils$ReactHooksTemplate.timeout), undefined));
                                          }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/dashboards", Dashboard$ReactHooksTemplate.fromJson)));
                        }), clearTempFilter())));
        }), []);
  var onDashboardChange = function (dashboard) {
    Curry._1(dispatch, {
          TAG: "ChangeDashboard",
          _0: dashboard
        });
  };
  var tmp;
  if (state.loading) {
    tmp = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                img: Caml_option.some(Image$ReactHooksTemplate.dashboardLoading),
                text: "Loading Dashboards"
              }),
          className: "h-screen w-full animated fadeIn"
        });
  } else {
    var match$1 = state.currentRef;
    var match$2 = state.dashboard;
    if (match$1 !== undefined && match$2 !== undefined) {
      var dashboard = Caml_option.valFromOption(match$2);
      tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {
            children: Caml_option.some(JsxRuntime.jsx(DashboardComponent$ReactHooksTemplate.make, {
                      dashboard: dashboard,
                      dashboards: state.dashboards,
                      drillDownChartDetails: state.drillDownChartDetails,
                      onClick: (function (key, chartId, xs) {
                          if (typeof xs !== "object") {
                            return ;
                          }
                          if (xs.TAG === "DrillDown") {
                            var x = xs._0;
                            var match = state.drillDownChartDetails;
                            var empty = match !== undefined ? match[1] === key : false;
                            var selectedFilter;
                            if (empty) {
                              selectedFilter = /* [] */0;
                            } else {
                              var ys = Filter$ReactHooksTemplate.filterType(x);
                              var tmp;
                              tmp = ys.TAG === "List" ? ({
                                    TAG: "List",
                                    _0: ListFilter$ReactHooksTemplate.setSelected(key, ys._0)
                                  }) : Filter$ReactHooksTemplate.filterType(x);
                              selectedFilter = {
                                hd: Filter$ReactHooksTemplate.setFilterTypes(tmp, x),
                                tl: /* [] */0
                              };
                            }
                            Js_promise.$$catch((function (err) {
                                    return Promise.resolve((console.log(err), undefined));
                                  }), Js_promise.then_((function (param) {
                                        return Promise.resolve(empty ? Curry._1(dispatch, {
                                                          TAG: "DrillDown",
                                                          _0: undefined
                                                        }) : Curry._1(dispatch, {
                                                          TAG: "DrillDown",
                                                          _0: [
                                                            chartId,
                                                            key
                                                          ]
                                                        }));
                                      }), Http$ReactHooksTemplate.fetchPostEncodedJSON("/api/v1/filters", Json_encode.object_({
                                              hd: [
                                                "scope",
                                                "temporary"
                                              ],
                                              tl: {
                                                hd: [
                                                  "filters",
                                                  Json_encode.list(Filter$ReactHooksTemplate.encode, selectedFilter)
                                                ],
                                                tl: /* [] */0
                                              }
                                            }))));
                            return ;
                          }
                          var toDashboard = List.find_opt((function (y) {
                                  return Dashboard$ReactHooksTemplate.name(y) === key;
                                }), state.dashboards);
                          if (toDashboard === undefined) {
                            return ;
                          }
                          var toDashboard$1 = Caml_option.valFromOption(toDashboard);
                          Js_promise.then_((function (param) {
                                  return Promise.resolve(Curry._1(dispatch, {
                                                  TAG: "GoToLinkedDashboard",
                                                  _0: toDashboard$1,
                                                  _1: List.append({
                                                        hd: Dashboard$ReactHooksTemplate.id(dashboard),
                                                        tl: /* [] */0
                                                      }, navigationIds)
                                                }));
                                }), clearTempFilter());
                        }),
                      onDashboardChange: onDashboardChange,
                      breadCrumbs: breadCrumbs(navigationIds),
                      currentRef: Caml_option.valFromOption(match$1),
                      breadCrumbsOnClick: (function (item, index) {
                          Js_promise.then_((function (param) {
                                  return Promise.resolve(Curry._1(dispatch, {
                                                  TAG: "GoToClickedDashboard",
                                                  _0: item,
                                                  _1: index,
                                                  _2: navigationIds
                                                }));
                                }), clearTempFilter());
                        })
                    }))
          });
    } else {
      tmp = "No Dashboards are loaded for the application.";
    }
  }
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(tmp)
            });
}

var make = Dashboards;

exports.lableFunction = lableFunction;
exports.initialState = initialState;
exports.buildNavigationParam = buildNavigationParam;
exports.reducer = reducer;
exports.make = make;
/* react Not a pure module */
